import propTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { getCompany } from 'helpers/getCompanyVariables';
import { useNavigate } from 'react-router-dom';
import ContentWithSidebar from 'tailwind-components/ContentWithSidebar/ContentWithSidebar';
import Licenses from './Licenses';
import Modal from 'tailwind-components/Modal/Modal';
import SendEmailConfirmationForm from 'components/SendEmailConfirmationForm/SendEmailConfirmationForm';
import ModalActionConfirmation from 'components/ModalActionConfirmation/ModalActionConfirmation';
import { sendEmailModifyAgentData } from 'state/actions/user';
import Main from './Main';

const company = getCompany();
const isOneill = company === 'oneill';

export default function MyProfile({
  refreshUser,
  setLocalLoader,
  zohoData: user
}) {
  const [isOpenPrimaryModal, setIsOpenPrimaryModal] = useState(false);
  const [isOpenSecondaryModal, setIsOpenSecondaryModal] = useState(false);
  const [modalText, setModalText] = useState('');
  const [focusEditBankingInfo, setFocusEditBankingInfo] = useState(false);
  const cancelTokenSource = axios.CancelToken.source();
  const agencyId = user?.Account_Name?.id;
  const navigate = useNavigate();
  const editButtonRef = useRef(null);

  async function refreshUserWrapper() {
    setLocalLoader(true);
    await refreshUser(() => setLocalLoader(false), cancelTokenSource);
  }

  useEffect(() => {
    refreshUserWrapper();
    const shouldFocus = !!sessionStorage.getItem('focus_personal_banking_edit');
    setFocusEditBankingInfo(shouldFocus);
    sessionStorage.removeItem('focus_personal_banking_edit');

    return () => {
      cancelTokenSource.cancel('API Call Canceled');
    };
  }, []);

  useEffect(() => {
    if (focusEditBankingInfo && editButtonRef.current) {
      setLocalLoader(false);
      setTimeout(() => {
        editButtonRef.current.focus();
        editButtonRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 300);
    }
  }, [focusEditBankingInfo]);

  return (
    <>
      <ContentWithSidebar
        mainContent={
          <Main
            editButtonRef={editButtonRef}
            setModalText={setModalText}
            setIsOpenPrimaryModal={setIsOpenPrimaryModal}
            setIsOpenSecondaryModal={setIsOpenSecondaryModal}
            refreshUser={refreshUserWrapper}
          />
        }
        sidebarContent={<Licenses />}
      />

      {/* Modals to send confirm email */}
      {isOneill && (
        <Modal
          size='large'
          title={"You're about to update your Personal Bank Information"}
          active={isOpenSecondaryModal}
          closeModal={() => setIsOpenSecondaryModal(false)}
        >
          <ModalActionConfirmation
            onCancel={() => setIsOpenSecondaryModal(false)}
            modalText={
              '<p>Want to update your Agency Bank Info instead?</p>' +
              '<ul>' +
              '<li>Go to Agency Management <strong>></strong> Settings</strong></li>' +
              '<li>Or click the button below to be redirected</strong></li>' +
              '</ul>'
            }
            primaryButtonText={'Edit Personal Bank Info'}
            secondaryButtonText={'Go to Agency Bank Info'}
            onPrimaryConfirm={() => setIsOpenPrimaryModal(true)}
            onSecondaryConfirm={() => {
              navigate(`/agencies/${agencyId}/settings`);
              sessionStorage.setItem('focus_agency_banking_edit', true);
            }}
          />
        </Modal>
      )}
      <Modal
        active={isOpenPrimaryModal}
        closeModal={() => setIsOpenPrimaryModal(false)}
        title={modalText}
      >
        <SendEmailConfirmationForm
          closeModal={() => setIsOpenPrimaryModal(false)}
          modalText={`We will send you an email with links to securely update your <strong>${modalText}</strong>.<br/><br/>Please click "Send" below.`}
          dispatchFunction={sendEmailModifyAgentData}
        />
      </Modal>
    </>
  );
}

MyProfile.propTypes = {
  refreshUser: propTypes.func,
  setLocalLoader: propTypes.func,
  zohoData: propTypes.object
};
